import {
  ITQConnectConfig,
  ITQConnectConfigResult,
} from '../types/tqConnectTypes/index';
import API from './';

export default class TQConnectAPI {
  static hostTQConnectConfigRoot = '/api/v1/hosts/configuration/tq-connect';

  /**
   * Get TQ Connect config for host (code = 200)
   */
  static getTQConnectConfig = () => {
    return API.get<ITQConnectConfigResult>(`${this.hostTQConnectConfigRoot}`);
  };

  /**
   * Update TQ Connect config in host (code = 200)
   */
  static updateTQConnectConfig = (tqConnectConfig: ITQConnectConfig) => {
    return API.put<{
      tqConnectConfig: ITQConnectConfig;
    }>(`${this.hostTQConnectConfigRoot}`, { tqConnectConfig });
  };
}
